import React from 'react';

function formatDocument(props){
    let {cnpj} = props;
    return(
    <span>{ cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") }</span>
    )
}

export default formatDocument;